import { render, staticRenderFns } from "./recent-searches.vue?vue&type=template&id=e77784c0"
import script from "./recent-searches.vue?vue&type=script&lang=js"
export * from "./recent-searches.vue?vue&type=script&lang=js"
import style0 from "./recent-searches.vue?vue&type=style&index=0&id=e77784c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
